export class AppliedPhaseModel {
    public phaseId: number;
    public phaseType: string;
 }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/appliedPhase/applied.phase.model.ts